import React from 'react';
import { useTranslation } from "react-i18next";

import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import QVContainer from './QVContainer';
import { fullWidth } from '../../sx/common';

import ReservationSection from './ReservationSection';

export default function ArticleReservationSection(props) {
    const { t } = useTranslation();
    const { item, onChangeQuantity, showQuantity, showAddToCartButton, loadingAvailability, direction, sx, children, showReservationSection = true, onClose } = props;

    return (
        <QVContainer borderRadius={8} sx={{ ...fullWidth, ...sx }}>
            <Stack sx={{ m: 1, width: '100%' }} direction='column' spacing={3}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                    <Typography variant="h6">{t("booking")}</Typography>
                    {onClose && <IconButton aria-label="Schließen" onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>}
                </Stack>
                {showReservationSection && <ReservationSection direction={direction} loadingAvailability={loadingAvailability} item={item} showQuantity={showQuantity} onChangeQuantity={onChangeQuantity} showAddToCartButton={showAddToCartButton} />}
                {children}
            </Stack>
        </QVContainer>
    );
};
